import React from 'react';

export default function Special({ mobile = false }) {
  return (
    <>
      <div className="stage stage-service border-top-grey">
        <div className="ac-special-content">
          <ul>
            <li className="ac-service-qualitygoods text-center">
              <b className="iconfont-symbol-products ico-quality-goods"></b>官方正品
            </li>
            <li className="ac-service-postage text-center">
              <b className="iconfont-symbol-products ico-postage"></b>顺丰极速达
            </li>
            <li className="ac-service-exchange text-center">
              <b className="iconfont-symbol-products ico-customer-guarantee"></b>全国联保
            </li>
            <li className="ac-service-customerservice text-center">
              <b className="iconfont-symbol-products ico-customer-laser"></b>镭射雕刻
            </li>
          </ul>
        </div>
      </div>
    </>
  );
}
